import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { DataTable } from '@/v2/components/DataTable/tasks/components/data-table';
import { DataTableColumnHeader } from '@/v2/components/DataTable/tasks/components/data-table-column-header';
import { format } from 'date-fns';
import useFetch from 'use-http';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import {
  useUserDispatch,
  useUserState,
} from '@/components/context/UserContext';
import { getQueryString } from '@/components/constants/visitsQueryStringBuilder';
import { InfoButton } from '@/components/ui/shared/InfoButton';

export default function ComplexServicesTable() {
  const history = useHistory();
  const userState = useUserState();
  const sessionDispatch = useUserDispatch();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [search, setSearch] = useState('');
  const [dateRange, setDateRange] = useState(userState.dateFilter);

  const { get: getResearches, response: getResearchesResponse } = useFetch(
    '/UserAccount/UserComplexServices',
  );

  const fetchData = async (
    date = dateRange,
    term = search,
    filter = selectedFilter,
  ) => {
    setIsLoading(true);
    sessionDispatch({
      type: 'UPDATE',
      data: { dateFilter: date },
    });

    const response = await getResearches(
      getQueryString(date, term, null, filter, userState.espbiEsi),
    );

    if (getResearchesResponse.ok) {
      const sorted = _.orderBy(response, ['date'], ['desc']);
      setData(sorted);

      if (!filters.length) {
        const uniqueStatuses = [
          ...new Set(response.map((x) => x.validityStatus)),
        ];
        setFilters(uniqueStatuses.map((val) => ({ value: val, label: val })));
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [dateRange]);

  const handleSelection = (obj) => {
    setIsLoading(true);
    history.push('/userAccount/complex-services/details', { data: obj });
  };

  return (
    <DataTable
      title="Kompleksinės paslaugos"
      loading={isLoading}
      columns={columns({ handleSelection })}
      data={data}
      filterableColumns={['serviceName', 'validityStatus', 'date']}
      onRowClick={(row) => handleSelection(row)}
    />
  );
}

const columns = ({ handleSelection }) => [
  {
    accessorKey: 'serviceName',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="PASLAUGA" />
    ),
    cell: ({ row }) => (
      <span className="font-medium max-w-[400px] truncate cursor-pointer capitalize">
        {row.original.serviceName}
      </span>
    ),
  },
  {
    accessorKey: 'date',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="DATA" />
    ),
    cell: ({ row }) => {
      const rawDate = new Date(row.original.date);
      const isMidnight =
        rawDate.getUTCHours() === 0 && rawDate.getUTCMinutes() === 0;
      return (
        <span className="text-muted-foreground">
          {isMidnight
            ? format(rawDate, 'yyyy-MM-dd')
            : format(rawDate, 'yyyy-MM-dd HH:mm')}
        </span>
      );
    },
  },
  {
    accessorKey: 'validityStatus',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="BŪSENA" />
    ),

    cell: ({ row }) => {
      const statusId = row.original.validityStatus;
      const variant = statusId === 'Galioja' ? 'success' : 'neutral';

      return <Badge variant={variant}>{statusId}</Badge>;
    },
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <InfoButton
          onClick={(e) => {
            e.stopPropagation();
            handleSelection(row.original);
          }}
        >
          Informacija
        </InfoButton>
      </div>
    ),
  },
];
